import { render, staticRenderFns } from "./MapBoxPopup.vue?vue&type=template&id=48ae4d23&"
import script from "./MapBoxPopup.vue?vue&type=script&lang=js&"
export * from "./MapBoxPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports